import { ButtonMode, ButtonProps, ButtonVariant } from '@naturalcycles/ncuikit'
import { ButtonTheme } from '@src/components/button/Button.component'

export function themeToUiKitButton(theme: ButtonTheme): Pick<ButtonProps, 'mode' | 'variant'> {
  if (['ghost', 'transparentPurple'].includes(theme)) {
    return {
      mode: ButtonMode.LIGHT,
      variant: ButtonVariant.SECONDARY,
    }
  }

  if (theme === 'ghostWhite') {
    return {
      mode: ButtonMode.DARK,
      variant: ButtonVariant.SECONDARY,
    }
  }

  if (['shimmerGradient', 'brandSalmon', 'brandBlue2023', 'whiteBrandPurple'].includes(theme)) {
    return {
      mode: ButtonMode.DARK,
      variant: ButtonVariant.PRIMARY,
    }
  }

  return {
    mode: ButtonMode.LIGHT,
    variant: ButtonVariant.PRIMARY,
  }
}
